<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterLink } from 'vue-router';
import { usePrinter } from '../print/usePrinter';

const { settings, state, target, message, check } = usePrinter();

const BADGE = {
  unconfigured: ['Non configurée', 'bg-creux text-encre-douce'],
  unverified: ['À vérifier', 'bg-creux text-encre-douce'],
  checking: ['Vérification…', 'bg-creux text-encre-douce'],
  online: ['Connectée', 'bg-succes-doux text-succes-texte'],
  offline: ['Hors ligne', 'bg-alerte-doux text-alerte-texte'],
} as const;

// Une seule vérification à l'ouverture : l'état affiché est celui d'une connexion qui vient de répondre.
onMounted(() => {
  if (state.value !== 'unconfigured') void check();
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <p
      class="text-encre-douce text-[12px] leading-[14px] font-semibold tracking-[0.9px] uppercase"
    >
      Imprimante
    </p>
    <div class="bg-creux flex items-center gap-3 rounded-[24px] p-4">
      <div class="min-w-0 flex-1">
        <p
          v-if="state === 'unconfigured'"
          class="text-[14px] leading-[20px] font-semibold"
        >
          Aucune imprimante choisie
        </p>
        <p v-else class="truncate text-[14px] leading-[20px] font-semibold">
          {{ settings.label || target }}
        </p>
        <p class="text-encre-douce text-[12px] leading-[17px]">
          <template v-if="state === 'unconfigured'">
            Choisissez-la dans
            <RouterLink to="/reglages/imprimante" class="underline"
              >les réglages</RouterLink
            >.
          </template>
          <template v-else>
            {{ settings.transport === 'network' ? 'Réseau local' : 'USB' }} ·
            {{ target }}
          </template>
        </p>
      </div>
      <span
        class="inline-flex h-7 items-center rounded-[8px] px-[10px] text-[12px] font-semibold"
        :class="BADGE[state][1]"
      >
        {{ BADGE[state][0] }}
      </span>
    </div>
    <p
      v-if="state === 'offline' && message"
      role="alert"
      class="text-alerte-texte text-[12px] leading-[17px]"
    >
      {{ message }}
    </p>
  </div>
</template>
